import { useMemo } from 'react'
import { useFeatureSwitch } from '../../../utils/features/FeatureSwitchContext'
import { FeatureSwitch } from '../../../utils/features/featureSwitches'
import { getRecommendedPriceExperimentState } from '../../../utils/features/recommendedPriceExperiment'

export function useRecommendedPriceExperimentTracking(isRecommendedPriceFlowOptionEnabled: boolean) {
  const { value: recommendedPriceFeatureValue, isLoadedFromBackend } = useFeatureSwitch(
    FeatureSwitch.PPA_12930_RECOMMENDED_PRICE_WITH_MIETSPIEGEL
  )

  return useMemo(
    () =>
      getRecommendedPriceExperimentState({
        isRecommendedPriceFlowOptionEnabled,
        isRecommendedPriceFeatureLoadedFromBackend: isLoadedFromBackend,
        recommendedPriceFeatureValue,
      }).trackingParameters,
    [isRecommendedPriceFlowOptionEnabled, isLoadedFromBackend, recommendedPriceFeatureValue]
  )
}
